<template>
	<draggable class="ly-draggable" :class="modules.length < 1 ? 'ly-drag-space' : ''"  tag="Collapse" :list="modules" group="people">
		<Panel v-for="(el,i) in modules" :key="i" :name="el.name">
			<div class="panel-content" :class="mark == el.name ? 'panel-content-change' : ''"  @click="panelClick(el)">
				{{el.name}} 
				<ButtonGroup size="small">
					<Button icon="md-add" @click.stop="btnEmit('add', el)"></Button>
					<Button icon="md-create" @click.stop="btnEmit('edit', el)"></Button>
					<Button icon="md-trash" @click.stop="delModule(i)"></Button>
				</ButtonGroup>
			</div>
			<div slot="content">
				<ly-nested-draggable :mark="mark" :modules="el.modules" @change="panelClick" @click="listenBtnEmit"/>
			</div>
		</Panel>
	</draggable>
</template>
<script>
	// https://g6.antv.vision/zh/examples/net/forceDirected#forceDirectedFunctionalParams
	import draggable from "vuedraggable"
	export default {
		props: {
			modules: {
				required: true,
				type: Array
			},
			mark: { // 选中模块的标识
				type: String,
				default: ""
			}
		},
		components: {
			draggable
		},
		name: "ly-nested-draggable",
		data () {
			return {
				panelChange: ''
			}
		},
		methods: {
			panelClick (el) {
				this.$emit('change', el)
			},
			btnEmit (type, module) {
				this.$emit('click', {
					type,
					module
				})
			},
			listenBtnEmit (obj) {
				this.$emit('click', obj)
			},
			delModule (index) {
				this.$Modal.confirm({
                    title: '删除确认',
                    content: '你确定要删除此模块？(子模版将一同被删除)',
                    onOk: () => {
						const module = this.modules[index]
						// 2023-07-20记录，说的是删除模块要求请求删除接口，不与保存一样
						this.$api.delete('pc/mconfig/' + module.id)
						this.modules.splice(index, 1)
                    },
                    onCancel: () => {
                    }
                });
			}
		}
	}
</script>
<style scoped>
	.panel-content {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		padding-left: 40px;
		/* background-color: #08a; */
	}
	.panel-content-change {
		color: #57a3f3;
		font-weight: bold;
	}
	.ly-drag-space {
		position: relative;
		min-height: 50px;
		border-style: dashed;
		background-color: #fff;
	}
	.ly-drag-space::after {
		content: "将模块拖拽到此处";
		position: absolute;
		top: 12px;
		left: 50%;
		margin-left: -56px;
		color: #aaaaaa;
	}
	.ly-draggable .ivu-btn-group {
		float: right;
		margin: 7px 5px 0 0;
	}
	.ly-draggable-company {
		position: relative;
		/* padding: 5px; */
		/* border: 1px dashed #dcdee2; */
		background-color: #fff;
	}
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/drag-list/src/nested.vue